export const IS_DEV_ENV = process.env.REACT_APP_ENV === 'development' && process.env.NODE_ENV === 'production';
export const IS_STAGING_ENV = process.env.REACT_APP_ENV === 'staging' && process.env.NODE_ENV === 'production';
export const IS_PROD_ENV = process.env.REACT_APP_ENV === 'production' && process.env.NODE_ENV === 'production';

export const Configs = {
  Breakpoints: {
    Sm: 640,
    Md: 768,
    Lg: 1024,
    Xl: 1280,
  },
  Help: {
    FAQLink: 'https://help.gloo.us/en/',
    TermsOfService: 'https://www.gloo.us/legal/entity-termsofservice',
    PrivacyPolicy: 'https://www.gloo.us/legal/privacy-statement',
    HowTo: {
      BroadcastCredits:
        'https://help.gloo.us/en/articles/5536507-what-are-message-credits-how-are-they-counted-and-tracked',
    },
  },
  Recovery: {
    RCI: {
      HowRCIWorksBlog: 'https://www.recoverycapital.io/how-the-rci-works',
      HowRsCIWorksBlog: 'https://www.recoverycapital.io/how-the-resilience-capital-index-works',
      BrandName: 'RCI',
      TermsOfService: 'https://www.recoverycapital.io/terms-of-use',
      PrivacyPolicy: 'https://www.recoverycapital.io/privacy-policy',
    },
  },
  Sms: {
    EmojiSegmentLimit: 70,
    CharacterSegmentLimit: 160,
    EmojiSegmentLimitWhenMulti: 67,
    CharacterSegmentLimitWhenMulti: 153,
    CharCount1: 160,
    CharCount2: 306,
    CharCount3: 459,
    CharCount8: 1224,
    EmojiCharCount1: 70,
    EmojiCharCount2: 134,
    EmojiCharCount3: 201,
    EmojiCharCount8: 536,
    MediaMessageCost: 3,
    VideoMaxSize: { size: 500 * 1024 * 1024, label: '500 MB' },
  },
  Pagination: {
    DefaultLimit: 50,
  },
  ContextConfigs: {
    MaxQuestions: 50,
  },
  Devotionals: {
    TimeInterval: 15,
    MaxMessages: 500,
    MaxDaysOut: 365,
  },
  Domain: {
    BaseUrl: process.env.REACT_APP_BASE_URL,
  },
  GoogleTagManager: {
    Key: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
  },
};

export const REDUX_ACTIONS = {
  REDUX_LOG: 'REDUX_LOG',
  REQUEST_FETCH: 'REQUEST_FETCH',
  REQUEST_FAIL: 'REQUEST_FAIL',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  UPDATE_FIREBASE_USER: 'UPDATE_FIREBASE_USER',
  UPDATE_ME: 'UPDATE_ME',
  LOGIN: 'LOGIN',
  LOGIN_WITHOUT_ACCOUNT: 'LOGIN_WITHOUT_ACCOUNT',
  LOGOUT: 'LOGOUT',
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',
  SET_DATA: 'SET_DATA',
  CLEAR_CACHE_TIME: 'CLEAR_CACHE_TIME',
  CLEAR_ALL_CACHE_TIME: 'CLEAR_ALL_CACHE_TIME',
  UPDATE_DATA: 'UPDATE_DATA',
  DELETE_DATA: 'DELETE_DATA',
  UPDATE_FILTERS: 'UPDATE_FILTERS',
  SET_NEXT_PAGE_DATA: 'SET_NEXT_PAGE_DATA',
  CHANGE_ORG: 'CHANGE_ORG',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  SET_NOTIFICATION_COUNT: 'SET_NOTIFICATION_COUNT',
  UPDATE_FEATURE_FLAGS: 'UPDATE_FEATURE_FLAGS',
  ALERT_BANNER_SHOW: 'ALERT_BANNER_SHOW',
  ALERT_BANNER_DISMISS: 'ALERT_BANNER_DISMISS',
  UPDATE_KIT_OR_HUB_IN_PROGRESS: 'UPDATE_KIT_OR_HUB_IN_PROGRESS',
  SET_BRANDING: 'SET_BRANDING',
  UPDATE_DRAFT_MESSAGE: 'UPDATE_DRAFT_MESSAGE',
  DELETE_DRAFT_MESSAGE: 'DELETE_DRAFT_MESSAGE',
  UPDATE_DEVICE_DATA: 'UPDATE_DEVICE_DATA',
};
